import React from "react";
import styles from "../../pages/perennial-mandalism/perennialmandalism.module.css";
import Link from "next/link";
import { Button } from "@mui/material";
import { useRouter } from "next/router";

const PerrenialMandalismBlock = ({
  data,
  signUpModalState,
  setSignUpModalState,
}) => {
  const router = useRouter();

  const insertAfterIndex = Math.floor(data.length / 2) - 1;

  return (
    <>
      {data.map((block, index) => (
        <React.Fragment key={`block-${index}`}>
          <div className={styles[`perennial_block${index + 3}_main`]}>
            <div
              className={`${styles.perennial_mandalism_main_wrpr} ${
                index % 2 !== 0 ? styles.reverse_wrpr : ""
              }`}
            >
              <div className={styles.img_section}>
                <img
                  className={styles[`block${index + 3}_part1_img`]}
                  src={block.blockImg}
                  alt="Block Image"
                />
                <div
                  className={
                    styles.perennial_mandalism_sign_up_button_container
                  }
                >
                  {/* {/ <button onClick={()=>setCopyRightOpen(true)} className={styles.perennial_mandalism_sign_up_button}>Join our Perennial Mandalin Community</button > /} */}
                  {/* <button onClick={() => setSignUpModalState(true)} className={styles.perennial_mandalism_sign_up_button}>Join our Perennial Mandalin Community</button> */}
                  <Link
                    href="/perennial-signup"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.perennial_mandalism_sign_up_button}
                  >
                    Join our Perennial Mandalin Community
                  </Link>
                </div>
              </div>

              <div className={styles.perennial_mandalism_content_sec}>
                <div className={styles.perennial_mandalism_text_sec_sub}>
                  {block.mainHeading && (
                    <div className={styles.yellow_heading_bar}>
                      <h1>{block.mainHeading}</h1>
                    </div>
                  )}

                  {block.mainDescription && <p>{block.mainDescription}</p>}

                  {block.contentWithPoints.map((content, i) => (
                    <div key={i}>
                      <div className={styles.brown_heading_arrow}>
                        <h2>{content.title}</h2>
                      </div>
                      <p>{content.description}</p>
                      <h5>
                        "
                        <span className={styles.highlighted_quote}>
                          {content.point.split('"')[1]}
                        </span>
                        "{content.point.split('"')[2]}
                      </h5>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          {index === insertAfterIndex && (
            <div
              key={`cta-${index}`}
              className={styles.parannial_new_18Aug_main_wrp_New}
            >
              <div className={styles.parannial_new_18Aug_main_sub_wrp}>
                <p>
                  As Perennial Mandalins, we honor astrology together as friends
                  and family within a community of like-minded individuals. Our
                  foundation is the practice of astrology alongside the Mandalin
                  Five-Fold Creed.
                </p>

                <Button
                  className={styles.parannial_new_18Aug_main_Btn}
                  onClick={() => router.push("/astrology-community")}
                >
                  Explore the Astrology Community
                </Button>
              </div>
            </div>
          )}
        </React.Fragment>
      ))}
    </>
  );
};

export default PerrenialMandalismBlock;